import App from "./components/App";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import * as React from "react";
import { createRoot } from "react-dom/client";
/* global document, Office, module, require */

initializeIcons();

let isOfficeInitialized = false;

const title = "Send2SACC";

const container = document.getElementById("container");
const root = createRoot(container);

const render = (Component) => {
  root.render(
<Component title={title} isOfficeInitialized={isOfficeInitialized} />
  );
};

/* Render application after Office initializes */
Office.onReady(() => {
  isOfficeInitialized = true;
  render(App);
});

/* Initial render showing a progress bar */
render(App);
